function readCookie(name: string): string | undefined {
  const re = new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)');
  const match = document.cookie.match(re);
  if (!match || match[1] === undefined) return undefined;
  return decodeURIComponent(match[1]);
}

/** Reads Meta Pixel browser cookies that should flow into the CAPI user_data. */
export function readMetaCookies(): { fbp?: string; fbc?: string } {
  return {
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc'),
  };
}
